import { NGXLogger } from 'ngx-logger';
import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ExceptionEvent } from '../classes/exception-event';
import { DataExchangeService } from '../services/session/data-exchange.service';

@Injectable({
  providedIn: 'root'
})

// A wrapper service for ngx-logger to include an auth token when making Web API requests
export class CustomLoggerService {

    private readonly router = inject(Router);
    private readonly dataExchangeService = inject(DataExchangeService);
    private exceptionEvent = inject(ExceptionEvent);  

  constructor(private logger: NGXLogger) {
    const authToken = this.dataExchangeService.getAuthToken();

    const config = this.logger.getConfigSnapshot();
    config.customHttpHeaders = new HttpHeaders({'Authorization': 'Bearer ' + authToken})
    this.logger.updateConfig(config);    

  }

  logDebug(message: string, ...args: any[]): void {
    this.logger.debug(message, ...args);
  }

  logInfo(message: string, ...args: any[]): void {
    this.logger.info(message, ...args);
  }

  logWarn(message: string, ...args: any[]): void {
    this.logger.warn(message, ...args);
  }

  private logError(message: string, ...args: any[]): void {
    this.logger.error(message, ...args);
  }

  logException (
        source: string, code: string, sysMessage: string, 
        category: string, type: string = 'OTHER', severity: string = 'MODERATE', 
        messageForUser: string = 'System error - see the administrator'
  ) {
      this.exceptionEvent.initialize(source, code, sysMessage, type, category, severity);
      const exceptionJson = this.exceptionEvent.toJson();
      this.logError(exceptionJson);
      this.dataExchangeService.setMessageText(messageForUser || sysMessage);
      this.router.navigate(['/err']);    
  }


}